import { render, staticRenderFns } from "./shuttleChildernBox.vue?vue&type=template&id=71bef77b&scoped=true&"
import script from "./shuttleChildernBox.vue?vue&type=script&lang=ts&"
export * from "./shuttleChildernBox.vue?vue&type=script&lang=ts&"
import style1 from "./shuttleChildernBox.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bef77b",
  null
  
)

export default component.exports